import {Directive, inject, Input} from '@angular/core';
import {DetailFieldDefaults, MX_DETAIL_FIELD_DEFAULTS} from './detail-field.defaults';

@Directive({
  selector: '[mxDetailFieldDefaults]',
  providers: [
    {
      provide: MX_DETAIL_FIELD_DEFAULTS,
      useFactory: () => {
        // This factory runs lazily on first injection by some child, after this directive's inputs have been set.
        const parent: DetailFieldDefaults | null = inject(MX_DETAIL_FIELD_DEFAULTS, {optional: true, skipSelf: true});
        const directive: DetailFieldDefaultsDirective = inject(DetailFieldDefaultsDirective);

        return {...(parent ?? {}), ...(directive.defaults ?? {})};
      }
    }
  ]
})
export class DetailFieldDefaultsDirective {
  @Input('mxDetailFieldDefaults') public defaults: DetailFieldDefaults = {};
}
